export default import.meta.ROLLDOWN_FILE_URL_BwLgxTW3avOjVbBj0C9ikQ